'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _botFlow = require('./bot-flow.component');

var _botFlow2 = _interopRequireDefault(_botFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botFlowModule = _angular2.default.module('app.containers.bot-flow', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('botFlow', {
    url: '/bot-flows',
    template: '<bot-flow></bot-flow>'
  });
}).component('botFlow', _botFlow2.default);

exports.default = botFlowModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-flow/bot-flow.js
 **/